import { ActionTypes } from '../actions/actions';


const gateInitialState = {
    shown: true,
    formData: {
        firstName: {
            value: "",
            isValid: true,
            errorMessage: "",
        },
        lastName: {
            value: "",
            isValid: true,
            errorMessage: "",
        },
        email: {
            value: "",
            isValid: true,
            errorMessage: "",
        },
        phoneNumber: {
            value: "",
            isValid: true,
            errorMessage: "",
        },
        zipCode: {
            value: "",
            isValid: true,
            errorMessage: "",
        },
        barName: {
            value: "",
            isValid: true,
            errorMessage: "",
        },
        barConnection: {
            value: "",
            isValid: true,
            errorMessage: "",
        },
        subscribeToBlog:  {
            value: true,
            isValid: true,
            errorMessage: "",
        },
    },
    errorMessage: "",
};
export const gateReducer = (state = gateInitialState, action) => {
    let newState;

    switch (action.type) {
        case ActionTypes.SET_GATE_FORM_FIELD_VALUE:
            newState = {...state};
            newState.formData[action.field] = {
                value: action.value,
                isValid: action.isValid,
                errorMessage: action.errorMessage,
            };
            return newState;

        case ActionTypes.SET_GATE_STATE:
            newState = {...state};
            newState.shown = action.gateShown;
            newState.initialInputFormId = action.initialInputFormId;
            return newState;

        case ActionTypes.SET_GATE_ERROR_MESSAGE:
            newState = {...state};
            newState.errorMessage = action.errorMessage;
            return newState;

        default:
            return state
    }
};

const barProfitInputInitialState = {
    currency: "USD",
    breakdownsBySetName: {
        averageSittingInventory: {
            sectionCopy: {
                section: "Inventory & Ordering",
                title: "What is your average sitting inventory?",
                description: "Your bar's average sitting inventory is all unused beverage product sitting on your shelves or in storage.",
            },
            activeBreakdown: "total",
            fieldsByBreakdown: {
                category: {
                    valuesByField: {
                        wine: {
                            value: 0,
                            text: "$0",
                            isValid: true,
                            errorMessage: "",
                        },
                        beer: {
                            value: 0,
                            text: "$0",
                            isValid: true,
                            errorMessage: "",
                        },
                        spirits: {
                            value: 0,
                            text: "$0",
                            isValid: true,
                            errorMessage: "",
                        }
                    },
                    scaledSliderTicks: [0, 1000, 5000, 25000, 125000],
                },
                total: {
                    valuesByField: {
                        total: {
                            value: 0,
                            text: "$0",
                            isValid: true,
                            errorMessage: "",
                        }
                    },
                    scaledSliderTicks: [0, 2500, 10000, 50000, 250000],
                }
            },
        },
        annualSales: {
            sectionCopy: {
                section: "Sales & Profitability",
                title: "What are your average annual sales?",
                description: "Your bar's annual sales total is your expected revenue over the course of a year.",
            },
            activeBreakdown: "total",
            fieldsByBreakdown: {
                category: {
                    valuesByField: {
                        wine: {
                            value: 0,
                            text: "$0",
                            isValid: true,
                            errorMessage: "",
                        },
                        beer: {
                            value: 0,
                            text: "$0",
                            isValid: true,
                            errorMessage: "",
                        },
                        spirits: {
                            value: 0,
                            text: "$0",
                            isValid: true,
                            errorMessage: "",
                        }
                    },
                    scaledSliderTicks: [0, 20000, 100000, 500000, 2000000],
                },
                total: {
                    valuesByField: {
                        total: {
                            value: 0,
                            text: "$0",
                            isValid: true,
                            errorMessage: "",
                        }
                    },
                    scaledSliderTicks: [0, 50000, 250000, 1000000, 5000000],
                }
            }
        },
        pourCostPercent: {
            sectionCopy: {
                section: "Sales & Profitability",
                title: "What is your average pour cost?",
                description: "You can calculate your total or per-category pour cost by dividing inventory usage by sales.",
            },
            activeBreakdown: "total",
            fieldsByBreakdown: {
                category: {
                    valuesByField: {
                        wine: {
                            value: 0,
                            text: "0.0%",
                            isValid: true,
                            errorMessage: "",
                        },
                        beer: {
                            value: 0,
                            text: "0.0%",
                            isValid: true,
                            errorMessage: "",
                        },
                        spirits: {
                            value: 0,
                            text: "0.0%",
                            isValid: true,
                            errorMessage: "",
                        },
                        total: {
                            value: 0,
                            text: "0.0%",
                            isValid: true,
                            errorMessage: "",
                        }
                    },
                    scaledSliderTicks: [0, 10, 20, 40, 80],
                },
                total: {
                    valuesByField: {
                        total: {
                            value: 0,
                            text: "0.0%",
                            isValid: true,
                            errorMessage: "",
                        }
                    },
                    scaledSliderTicks: [0, 10, 20, 40, 80],
                }
            }
        },
    }
};
export const barProfitInputReducer = (state = barProfitInputInitialState, action) => {
    let newState;

    switch (action.type) {
        case ActionTypes.SET_ACTIVE_BREAKDOWN:
            newState = {...state};
            newState.breakdownsBySetName[action.setName] = { ...state.breakdownsBySetName[action.setName] };
            newState.breakdownsBySetName[action.setName].activeBreakdown = action.activeBreakdown;
            return newState;

        case ActionTypes.SET_FIELD_INPUTS:
            newState = {...state};
            newState.breakdownsBySetName[action.setName] = { ...state.breakdownsBySetName[action.setName] };
            newState.breakdownsBySetName[action.setName].fieldsByBreakdown[action.breakdown].valuesByField[action.field] = {
                value: action.value,
                text: action.text,
                isValid: action.isValid,
                errorMessage: action.errorMessage
            };
            return newState;

        case ActionTypes.SET_PRESENTATION_ID:
            newState = {...state};
            newState.presentationId = action.presentationId;
            return newState;

        default:
            return state
    }
};
